import UserProfile from './redux'
export default UserProfile
